import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './keycloack/keycloak-init.factory';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from './components/shared/shared-components.module';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { ApiCallsInterceptor } from './interceptors/ApiCallsInterceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IMAGE_CONFIG, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeIntl,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { ItalianOwlDateTimeIntl } from './locale/ItalianOwlDateTimeIntl';

registerLocaleData(localeIt);
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    importProvidersFrom(OwlDateTimeModule, OwlNativeDateTimeModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(KeycloakAngularModule),
    importProvidersFrom(SharedComponentsModule),
    importProvidersFrom(MatSnackBarModule),
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiCallsInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'it' },
    { provide: OwlDateTimeIntl, useClass: ItalianOwlDateTimeIntl },
  ],
};
